/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EPersonType } from "../types/EPersonType.ts";

/**
 * @description 1 = Employee | 2 = Teaching | 3 = Student | 4 = Monitor | 5 = Seller | 6 = Advisor | 7 = SellerManager | 8 = Coordinator |
 */
export const ePersonTypeSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
  ])
  .describe(
    "1 = Employee | 2 = Teaching | 3 = Student | 4 = Monitor | 5 = Seller | 6 = Advisor | 7 = SellerManager | 8 = Coordinator | ",
  ) as unknown as ToZod<EPersonType>;
